import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Select, Rate, Button, Skeleton, Typography } from 'antd';
import { AppstoreOutlined, BarsOutlined } from '@ant-design/icons';
import { BASE_URL } from '../constants/Url';
import Meta from 'antd/es/card/Meta';
import { useNavigate } from 'react-router';
import { productsData, productsHomeData } from '../constants/TempData';


const { Option } = Select;

const ProductList = () => {
    const { Text } = Typography;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true); // 👈 loading true first
    const [shop, setShop] = useState([
        {
            title: "",
            salePrice: "",
            originalPrice: "",
            image: [],
            code: "",
        }
    ]);
    useEffect(() => {
        fetchBlog();
    }, [])

    const fetchBlog = async () => {
        const res = productsHomeData;

        setShop([...res])
    }
    const handleViewDetail = (item) => {
        navigate(`/shop/${item.code}`, { state: { shop: item } });
    }

    // ⏳ setTimeout 1 minute (1000ms) to switch loading -> data
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false); // 🔥 stop loading after 1min
        }, 1000);

        return () => clearTimeout(timer); // Cleanup if unmount
    }, []);

    return (
        <div className="">
            <div className="flex justify-between items-center mb-5">
                <div className="space-x-2">
                    <Button icon={<AppstoreOutlined />} />
                    <Button icon={<BarsOutlined />} />
                </div>
                <Select defaultValue="default" style={{ width: 200 }}>
                    <Option value="default">Default sorting</Option>
                    <Option value="price-popularity">Sort by popularity</Option>
                    <Option value="price-rating">Sort by average rating</Option>
                    <Option value="price-lastest">Sort by latest</Option>
                    <Option value="price-low-high">Sort by price: low to high</Option>
                    <Option value="price-high-low">Sort by price: high to low</Option>
                </Select>
            </div>

            <Row gutter={[16, 16]}>
                {(loading ? Array(shop.length).fill({}) : shop).map((product, index) => (
                    <Col key={index} xs={24} sm={12} md={8} lg={6}>
                        {loading ? (
                            <Card
                                hoverable
                                style={{ width: '100%', height: '340px' }}
                                cover={
                                    <Skeleton.Image className='card-image-scarf' style={{ width: '100%', height: '200px', objectFit: 'cover' }} active />
                                }
                            >
                                <Skeleton active paragraph={{ rows: 2 }} />
                            </Card>
                        ) : (
                            <Card
                                hoverable
                                onClick={() => handleViewDetail(product)}
                                cover={
                                    <img
                                        alt={product.title}
                                        src={product?.image[0] || product.image}
                                        style={{ height: '200px', objectFit: 'cover' }}
                                    />
                                }
                            >
                                <div className="text-center d-flex row mb-3">
                                    <div className='labelHeader18600'>{product?.title}</div>
                                    {/* <div className='labelHeader18700'>$ {product?.salePrice}</div> */}
                                </div>
                                <div className="text-center">

                                    {/* <Rate disabled defaultValue={0} className="mt-3" /> */}
                                </div>
                            </Card>
                        )}
                    </Col>
                ))}
            </Row>

        </div>
    );
};

export default ProductList;
